import React from 'react';
import { Navigate } from 'react-router-dom';
import useUser from '../hooks/useUser';

/**
 * Componente que protege rutas basado en roles de usuario.
 * - requiredRole (string): el usuario debe tener ese rol exacto.
 * - requiredRoles (array): el usuario debe tener al menos uno de los roles indicados.
 * Si no cumple, redirige al inicio.
 */
const ProtectedRoute = ({ children, requiredRole, requiredRoles }) => {
    const { hasRole, hasAnyRole, isAuthenticated } = useUser();

    if (!isAuthenticated) {
        // Esto generalmente es manejado por AutoLogin, pero por seguridad:
        return <div>Cargando...</div>;
    }

    if (requiredRole && !hasRole(requiredRole)) {
        console.warn(`Acceso denegado: se requiere el rol ${requiredRole}`);
        return <Navigate to="/" replace />;
    }

    if (requiredRoles && !hasAnyRole(requiredRoles)) {
        console.warn(`Acceso denegado: se requiere alguno de los roles ${requiredRoles.join(', ')}`);
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
